import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormLabel,
  GridItem,
  Input,
  InputGroup,
  InputRightElement,
  SimpleGrid,
  Stack,
  Tooltip,
  useColorModeValue,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useProjectStore } from '../../../contexts/RootStoreProvider';
import PropTypes from 'prop-types';
import { isAssetsEnabled } from '../../../helpers/featureHelper';

const SharedProjectForm = (props: any) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const projectStore = useProjectStore();
  const textColor = useColorModeValue('navy.700', 'white');
  const brandStars = useColorModeValue('brand.500', 'brand.400');
  const [refresh, setRefresh] = useState(false);

  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  const validationSchema = yup.object({
    description: yup.string().required('Description is required'),
    showAssets: yup.boolean(),
    password: yup.string().when('showAssets', {
      is: true,
      then: (schema) =>
        schema.required('Password Required with Sharing Assets!'),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  const checkHandler = () => {
    setRefresh(!refresh);
  };

  const handleCreateUpdateSharedProject = async (sharedProjectObj: any) => {
    setIsLoading(true);

    if (props.sharedProject) {
      var updateProject = props.sharedProject;

      updateProject.description = sharedProjectObj.description;
      updateProject.showAssets = sharedProjectObj.showAssets;
      updateProject.showNotes = sharedProjectObj.showNotes;
      updateProject.showMedia = sharedProjectObj.showMedia;
      updateProject.password = sharedProjectObj.password || undefined;

      await projectStore
        .updateSharedProject(updateProject, refresh)
        .then((response: any) => {
          alert(response.result);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      sharedProjectObj.sharedProjectId = props.projectId;
      sharedProjectObj.availableUntil = new Date();

      await projectStore.createSharedProject(sharedProjectObj).finally(() => {
        setIsLoading(false);
 
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      description: props.sharedProject?.description || '',
      showAssets: props.sharedProject?.showAssets || false,
      showNotes: props.sharedProject?.showNotes || false,
      showMedia: props.sharedProject?.showNotes || false,
      availableUntil: props.sharedProject?.availableUntil || null,
      password: props.sharedProject?.password || undefined,
      regenerate: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleCreateUpdateSharedProject(values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <SimpleGrid
        columns={{ base: 2, sm: 1, md: 2, lg: 2 }}
        columnGap={3}
        rowGap={6}
      >
        <GridItem>
          <FormControl isRequired>
            <FormLabel>Description</FormLabel>
            <Input
              isRequired={true}
              id="description"
              name="description"
              fontSize="sm"
              ms={{ base: '0px', md: '0px' }}
              type="text"
              placeholder="Enter Description Here"
              color={textColor}
              onChange={formik.handleChange}
              value={formik.values.description}
            />
          </FormControl>
          {isAssetsEnabled() ? (
            <FormControl paddingTop={3}>
              <Tooltip
                label="Password isnt mandatory unless including asset details"
                fontSize="sm"
              >
                <FormLabel>Password</FormLabel>
              </Tooltip>

              <InputGroup size="md">
                <Input
                  id="password"
                  name="password"
                  fontSize="sm"
                  ms={{ base: '0px', md: '0px' }}
                  type={show ? 'text' : 'password'}
                  color={textColor}
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                <InputRightElement width="4.5rem">
                  <Button h="1.75rem" size="sm" onClick={handleClick}>
                    {show ? 'Hide' : 'Show'}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>
          ) : (
            <></>
          )}
        </GridItem>

        <GridItem>
          <FormLabel>Project Attributes</FormLabel>

          <CheckboxGroup>
            <Stack padding={2} spacing={[1, 5]} direction={['column', 'row']}>
              <Checkbox
                id="showNotes"
                onChange={formik.handleChange}
                name="showNotes"
                isChecked={formik.values.showNotes}
              >
                Include Notes
              </Checkbox>

              {isAssetsEnabled() ? (
                <>
                  <Checkbox
                    id="showAssets"
                    onChange={formik.handleChange}
                    name="showAssets"
                    isChecked={formik.values.showAssets}
                  >
                    Include Assets
                  </Checkbox>
                </>
              ) : (
                <></>
              )}
              <Checkbox
                id="showMedia"
                onChange={formik.handleChange}
                name="showMedia"
                isChecked={formik.values.showMedia}
              >
                Include Media
              </Checkbox>
            </Stack>
          </CheckboxGroup>

          {props.sharedProject ? (
            <CheckboxGroup>
              <Stack padding={2} spacing={[1, 5]} direction={['column', 'row']}>
                <Checkbox
                  id="regenerateTour"
                  onChange={checkHandler}
                  name="regenerateMedia"
                  isChecked={formik.values.regenerate}
                >
                  Regenerate Changes
                </Checkbox>
              </Stack>
            </CheckboxGroup>
          ) : (
            <></>
          )}
        </GridItem>
      </SimpleGrid>
      <FormControl>
        <Button
          type="submit"
          isLoading={isLoading}
          isDisabled={isLoading}
          color={brandStars}
          float={'right'}
          variant={'outline'}
          mt={'24px'}
        >
          Create
        </Button>
      </FormControl>
    </form>
  );
};

SharedProjectForm.propTypes = {
  projectId: PropTypes.string,
  projectStore: PropTypes.any,
  sharedProject: PropTypes.any,
  
};

export default SharedProjectForm;
